import { DeleteEvent, GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud/events';
import { deleteData, getData, patchData, postData } from '~/utils/service';
import { BoardCertFormValues } from './types';

import { BoardCertification } from '~/types/mcv/boardCertifications';
import { GridContext } from './types';
import {
  transformBoardCertsToFormValues,
  transformBoardCertToFormValues,
  transformFormValuesToApi,
} from './utils';

const ROUTE_NAME = 'boardCertification';

interface BoardCertGridInput<T> {
  input: {
    context: GridContext;
    event: T;
  };
}

export const BOARD_CERT_ROUTES = {
  get: '/board-certifications/{providerId}',
  post: '/board-certifications',
  patch: '/board-certifications/{id}',
  delete: '/board-certifications/{id}',
};

export const API_CALLS = {
  get: async ({ input }: BoardCertGridInput<GetEvent>): Promise<BoardCertification[]> => {
    return await getData(ROUTE_NAME, {
      pathParams: { providerId: input.context.providerId.toString() },
      transformResponse: transformBoardCertsToFormValues,
    });
  },
  create: async ({
    input,
  }: BoardCertGridInput<SubmitEvent<BoardCertFormValues>>): Promise<BoardCertification> => {
    return await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: transformFormValuesToApi,
      transformResponse: transformBoardCertToFormValues,
    });
  },
  delete: async ({ input }: BoardCertGridInput<DeleteEvent>) => {
    return await deleteData(ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  patch: async ({
    input,
  }: BoardCertGridInput<PatchEvent<BoardCertFormValues>>): Promise<BoardCertification> => {
    return await patchData(ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: transformFormValuesToApi,
      transformResponse: transformBoardCertToFormValues,
    });
  },
};
